<template>
    <AdminNextIframe
        path="/collections/"
        :query="{ clientId: $route.params.id }"
        @navigate="onNavigate"
        @back="onBack" />
</template>

<script>
import AdminNextIframe from '@/components/ui/iframe/AdminNextIframe';

export default {
    name: 'ClientCollections',
    components: { AdminNextIframe },
    methods: {
        // Create and detail are still legacy pages: the iframe asks the parent
        // to route to them.
        onNavigate(path) {
            const id = this.$route.params.id;

            if (path === '/collections/new') {
                this.$router.push({ name: 'client-collections-create', params: { id } }).catch(() => {});
                return;
            }

            const detail = path.match(/^\/collections\/([^/]+)$/);
            if (detail) {
                this.$router.push({
                    name: 'client-collections-details',
                    params: { id, collectionID: detail[1] }
                }).catch(() => {});
            }
        },
        onBack() {
            this.$router.push({
                name: 'client-recommerce',
                params: { id: this.$route.params.id }
            });
        }
    }
}
</script>
